import { render, staticRenderFns } from "./trauma.vue?vue&type=template&id=8124224e&scoped=true&"
import script from "./trauma.vue?vue&type=script&lang=js&"
export * from "./trauma.vue?vue&type=script&lang=js&"
import style0 from "./trauma.vue?vue&type=style&index=0&id=8124224e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8124224e",
  null
  
)

export default component.exports